import { render } from "./Accessi.vue?vue&type=template&id=ab703c8a&scoped=true"
import script from "./Accessi.vue?vue&type=script&lang=js"
export * from "./Accessi.vue?vue&type=script&lang=js"

import "./Accessi.vue?vue&type=style&index=0&id=ab703c8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab703c8a"]])

export default __exports__